export default "__VITE_ASSET__C34vPD9L__"